import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import ApiRequest from "../../helper/ApiRequest";
import { usePermissions } from "../../helper/PermissionContext";

const MENU = {
  userManagement: "user-management",
  dashboard: "dashboard",
  blogManagement: "blog-management",
  pressManagement: "press-management",
  seoManagement: "seo-management",
  sitemapManagement: "sitemap-management",
  faqManagement: "faq-management",
  caseManagement: "case-management",
  career: "career",
  locationPage: "location-page",
  globalSeo: "global-seo",
  llmsManagement: "llms-management",
  robotsManagement: "robots-management",
  emailManagement: "email-management",
  contactUs: "contact-us",
  serviceForm: "service-form",
  jobApplication: "job-application",
  newsletters: "newsletters",
};

export default function SideBar({ isOpen, toggleSidebar }) {
  const [isBlogManagementOpen, setIsBlogManagementOpen] = useState(false);
  const [iscaseManagementOpen, setIscaseManagementOpen] = useState(false);
  const [isjobManagementOpen, setIsjobManagementOpen] = useState(false);
const [isPressManagementOpen, setIsPressManagementOpen] = useState(false);
  const [isUserManagementOpen, setIsUserManagementOpen] = useState(false);
  const { hasPermission } = usePermissions();
  const navigate = useNavigate();

  const toggleBlogManagement = () => setIsBlogManagementOpen((prev) => !prev);
  const toggleCaseManagement = () => setIscaseManagementOpen((prev) => !prev);
  const togglejobManagement = () => setIsjobManagementOpen((prev) => !prev);
 const  togglePressManagement = () => setIsPressManagementOpen((prev) => !prev);
  const toggleUserManagement = () => setIsUserManagementOpen((prev) => !prev);
 

  const handleLogout = async () => {
    try {
      await ApiRequest("POST", "api/logout");
    } catch (error) {}
    localStorage.removeItem("accessTokenawl");
    localStorage.removeItem("username");
    localStorage.removeItem("email");
    navigate("/login");
  };

  return (
    <>
      <div className={`admin-logo-wrap ${isOpen ? "close" : "open"}`}>
        <img src="/assets/logo.webp" alt="logo" className="img-responsive" />
        <button className="toggle-button" onClick={toggleSidebar}>
          ☰
        </button>
      </div>
      <div className={`admin-sidebar ${isOpen ? "close" : "open"}`}>
        <div className="scroller-sidebar">
          <ul style={isOpen
            ? { transition: "all 0.3s ease-in", opacity: "0" }
            : { transition: "all 0.3s ease-in", opacity: "1" }}>

            {hasPermission(MENU.dashboard) && <li>
              <Link to="/"><span><img src="/assets/dashboard.webp" alt="icon" className="img-responsive" />Dashboard</span></Link>
            </li>}

            {hasPermission(MENU.userManagement) && (
              <li className={`innertab ${isUserManagementOpen ? "openlist" : ""}`} onClick={toggleUserManagement}>
                <div><span><img src="/assets/admin-user.webp" alt="icon" className="img-responsive" /> User Management</span> <Icons name="arrowDown" /></div>
                <ul className={`nested-list ${isUserManagementOpen ? "open" : "close"}`}>
                  <li><Link to="users">Users</Link></li>
                  <li><Link to="roles">Roles</Link></li>
                  <li><Link to="permissions">Permissions</Link></li>
                </ul>
              </li>
            )}

            {hasPermission(MENU.blogManagement) && <li className={`innertab ${isBlogManagementOpen ? "openlist" : ""}`} onClick={toggleBlogManagement}>
              <div><span><img src="/assets/blog-management.webp" alt="icon" className="img-responsive" /> Blog Management</span> <Icons name="arrowDown" /></div>
              <ul className={`nested-list ${isBlogManagementOpen ? "open" : "close"}`}>
                <li><Link to="blog">Blog</Link></li>
                <li><Link to="ai-blog">AI Blog</Link></li>
                <li><Link to="category">Category</Link></li>
                <li><Link to="author">Author</Link></li>
                <li><Link to="tag">Tag</Link></li>
              </ul>
            </li>}

              {hasPermission(MENU.pressManagement) && <li className={`innertab ${isPressManagementOpen ? "openlist" : ""}`} onClick={togglePressManagement}>
              <div><span><img src="/assets/blog-management.webp" alt="icon" className="img-responsive" /> Press Management</span> <Icons name="arrowDown" /></div>
              <ul className={`nested-list ${isPressManagementOpen ? "open" : "close"}`}>
                <li><Link to="press">Press Management</Link></li>
                {/* <li><Link to="category">Category</Link></li>
                <li><Link to="author">Author</Link></li>
                <li><Link to="tag">Tag</Link></li> */}
              </ul>
            </li>}

            {/* <li className={`innertab ${isSeoManagementOpen ? "openlist" : ""}`} onClick={toggleSeoManagement}>
              <div><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" /> SEO Management</span> <Icons name="arrowDown" /></div>
              <ul className={`nested-list ${isSeoManagementOpen ? "open" : "close"}`}>
                <li><Link to={"seo"}>SEO</Link></li>
                
                <li><Link to={"tracking-code"}>TrackingCode</Link></li>
              </ul>
            </li> */}

            {hasPermission(MENU.seoManagement) && <li><Link to={"seo"}><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" />SEO Management</span></Link></li>}

            {hasPermission(MENU.faqManagement) && <li>
              <Link to="faq"><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" />FAQ Management</span></Link>
            </li>}


            {hasPermission(MENU.caseManagement) && <li className={`innertab ${iscaseManagementOpen ? "openlist" : ""}`} onClick={toggleCaseManagement}>
              <div><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" /> Case Management</span> <Icons name="arrowDown" /></div>
              <ul className={`nested-list ${iscaseManagementOpen ? "open" : "close"}`}>
                <li><Link to={"case"}> Case Management</Link></li>
                <li><Link to={"case-category"}>Case  Category</Link></li>
              </ul>
            </li>}


            {hasPermission(MENU.career) && <li className={`innertab ${isjobManagementOpen ? "openlist" : ""}`} onClick={togglejobManagement}>
              <div><span><img src="/assets/blog-management.webp" alt="icon" className="img-responsive" />  Career </span> <Icons name="arrowDown" /></div>
              <ul className={`nested-list ${isjobManagementOpen ? "open" : "close"}`}>
                <li><Link to="/jobpost"> Job Post </Link></li>
                <li><Link to="/location"> Location</Link></li>
                <li><Link to="/operation">Department</Link></li>
                <li><Link to="/experience">Experience</Link></li>
              </ul>
            </li>}
            
             {hasPermission(MENU.locationPage) && <li>
              <Link to="location-page"><span><img src="/assets/media-management.webp" alt="icon" className="img-responsive" />Location Page</span></Link>
            </li>} 


            {hasPermission(MENU.globalSeo) && <li><Link to={"global-seo"}><span><img src="/assets/schema-management.webp" alt="icon" className="img-responsive" /> Global SEO</span></Link></li>}

            {hasPermission(MENU.sitemapManagement) && <li><Link to={"sitemap"}><span><img src="/assets/sitemap-management.webp" alt="icon" className="img-responsive" /> Sitemap Management</span></Link></li>}

            {hasPermission(MENU.llmsManagement) && <li><Link to={"llms"}><span><img src="/assets/sitemap-management.webp" alt="icon" className="img-responsive" /> LLMS Management</span></Link></li>}

            {hasPermission(MENU.robotsManagement) && <li><Link to={"robots"}><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" /> Robots.txt Management</span></Link></li>}

            {hasPermission(MENU.emailManagement) && <li><Link to={"email-management"}><span><img src="/assets/dashboard.webp" alt="icon" className="img-responsive" /> Email Management</span></Link></li>}

            {/* <li>
              <Link to="case"><span><img src="/assets/media-management.webp" alt="icon" className="img-responsive" /> Case Management</span></Link>
            </li> */}

            {/* <li>
              <Link to="branch"><span><img src="/assets/media-management.webp" alt="icon" className="img-responsive" /> Branch Management</span></Link>
            </li> */}

            {/* <li>
              <Link to="class"><span><img src="/assets/media-management.webp" alt="icon" className="img-responsive" /> Class Management</span></Link>
            </li> */}

            {/* <li>
              <Link to="fee-structure"><span><img src="/assets/media-management.webp" alt="icon" className="img-responsive" /> Fee Structure</span></Link>
            </li> */}

            {/* <li>
              <Link to="/"><span><img src="/assets/staff.webp" alt="icon" className="img-responsive" />Staff Management</span></Link>
            </li> */}

            {hasPermission(MENU.contactUs) && <li>
              <Link to={"/contact"}><span><img src="/assets/contact-management.webp" alt="icon" className="img-responsive" /> Contact Us</span></Link>
            </li>}

              {hasPermission(MENU.serviceForm) && <li>
              <Link to={"/service-form"}><span><img src="/assets/contact-management.webp" alt="icon" className="img-responsive" />  Service Form </span></Link>
            </li>}

            {hasPermission(MENU.jobApplication) && <li>
              <Link to={"/job-applications"}><span><img src="/assets/contact-management.webp" alt="icon" className="img-responsive" /> Job Applications</span></Link>
            </li>}

            {hasPermission(MENU.newsletters) && <li>
              <Link to={"/newsletters"}><span><img src="/assets/contact-management.webp" alt="icon" className="img-responsive" />Newsletters</span></Link>
            </li>}

            {/* <li>
              <Link to={"schedule-visit"}><span><img src="/assets/contact-management.webp" alt="icon" className="img-responsive" /> Schedule A Visit</span></Link>
            </li> */}

            {/* <li>
              <Link to={"apply-now"}><span><img src="/assets/contact-management.webp" alt="icon" className="img-responsive" /> Apply Now</span></Link>
            </li> */}

            {/* <li>
              <Link to={"career"}><span><img src="/assets/contact-management.webp" alt="icon" className="img-responsive" /> Career</span></Link>
            </li> */}
          </ul>
        </div>

        <button onClick={handleLogout} className="default-btn logout-button">Logout<span></span></button>
      </div>
    </>
  );
}
